/**
 * LT+ variant copy and behavior – drawer/confirmation text and flags keyed by variant.
 * Backend sends variant (e.g. 'draw-protection', 'sweepstakes', 'early-access', 'general'); we use these defaults when rendering.
 */

export type LtPlusVariantData = {
  header: string;
  subtext: string;
  ctaLabel: string;
  confirmationHeader: string;
  confirmationSubtext: string;
};

export const LT_PLUS_EXISTING_MEMBER_CONFIRMATION = {
  header: 'Your Membership Has You Covered!',
  subtext:
    'Your LandTrust Plus membership includes Draw Protection. If you don’t draw, you’ll be refunded for this hunt.',
};

export const LT_PLUS_VARIANT_DEFAULTS: Record<string, LtPlusVariantData> = {
  'draw-protection': {
    header: "Don't let draw results hold you back.",
    subtext:
      'Book today and get refunded if you don’t draw with LandTrust Plus. Applies to draw-required hunts like the one you are interested in.',
    ctaLabel: 'Learn More',
    confirmationHeader: 'You’ve Successfully Upgraded to Plus!',
    confirmationSubtext:
      'You can now book your hunt with the peace of mind of a full refund (minus processing fees) if you don’t draw for the hunt you’re interested in. ',
  },
  general: {
    header: 'Unlock exclusive membership perks.',
    subtext:
      'Join LandTrust Plus to unlock draw protection, early access to new properties, automatic entries into every LandTrust sweepstakes and more.',
    ctaLabel: 'Learn More',
    confirmationHeader: 'You’ve Successfully Upgraded to Plus!',
    confirmationSubtext:
      'You can now enjoy draw protection, early access to new hunting properties, unlimited access to Buck, and automatic entry into all Dream Hunt sweepstakes.',
  },
};

export function getLtPlusVariantData(variant?: string): LtPlusVariantData {
  const key = variant && variant in LT_PLUS_VARIANT_DEFAULTS ? variant : 'general';
  const data = LT_PLUS_VARIANT_DEFAULTS[key];
  return { ...data };
}
